import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback } from 'react';
import { ErrorBoundary as CommonErrorBoundary } from '@atlassian/search-common';
import { logger } from '../../utils';
var useLogException = function useLogException() {
  return useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(error) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            logger.error(error);
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
};
export var ErrorBoundary = function ErrorBoundary(props) {
  var onException = useLogException();
  return /*#__PURE__*/React.createElement(CommonErrorBoundary, _extends({}, props, {
    onException: onException
  }), props.children);
};